import { TodaysTime, TodaysTV, TodaysDefault } from "./icon-list";

export default {
  "todays-time": TodaysTime,
  "todays-tv": TodaysTV,
  "todays-default": TodaysDefault,
};
